import { authPaths } from '@noah-labs/shared-constants';

export const authRoutes = {
  ...authPaths,
  newPasswordComplete: '/auth/new-password/complete',
  newPasswordEntry: '/auth/new-password',
};
